import { CasErrorDisplay } from 'src/compass/shared/components';
import { CasLayoutDefinitions } from 'src/compass/application';

import { useDatasetLayoutIdParam } from './useDatasetLayoutIdParam';

export default function PublicLayoutInfoContainer() {
  const datasetLayoutId = useDatasetLayoutIdParam();

  if (!datasetLayoutId) return <CasErrorDisplay message="Invalid Request" />;

  // The view itself is shared with the Message Dataset Columns preview, so what an admin checks
  // before publishing wording is literally what the grower gets.
  return <CasLayoutDefinitions datasetLayoutId={datasetLayoutId} />;
}
